import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58a3ea80")

_pushScopeId("data-v-58a3ea80")
const _hoisted_1 = { class: "searc-block" }
const _hoisted_2 = { class: "searc-block__label" }
const _hoisted_3 = { class: "searc-block__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")

  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString($props.label), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_SvgIcon, { name: "search-blue" }),
      _createVNode("input", {
        type: "search",
        value: $props.modelValue,
        placeholder: $props.placeholder,
        class: "searc-block__input",
        onInput: _cache[1] || (_cache[1] = (...args) => ($options.updateValue(...args)))
      }, null, 40, ["value", "placeholder"])
    ])
  ]))
})